import { takeEvery, put, call } from 'redux-saga/effects';
import { Actions, getDeviceEventsRequest, getDeviceEventsSuccess, getDeviceEventsFailure } from 'actions/deviceEventsActions';
import { apiGet } from './apiSagas';
import { toError } from 'shared/util/toError';

export function* getDeviceEventsRequestWatcher() {
    yield takeEvery(Actions.GET_DEVICE_EVENTS_REQUEST, getDeviceEventsSaga);
}

function* getDeviceEventsSaga(action: ReturnType<typeof getDeviceEventsRequest>) {
    const deviceId = action.payload;
    const { olderThan, newerThan, rows } = action.meta;
    try {
        const queryParams = [
            olderThan ? `olderThan=${olderThan}` : null,
            newerThan ? `newerThan=${newerThan}` : null,
            rows ? `maxRows=${rows}` : null,
        ].filter(_ => _).join('&');

        const queryString = queryParams ? `?${queryParams}` : '';

        const url = `/api/devices/${deviceId}/events${queryString}`;

        const { events, remaining } = yield call(apiGet, url);
        yield put(getDeviceEventsSuccess(deviceId, events, remaining > 0));
    }
    catch (e) {
        const err = toError(e);
        yield put(getDeviceEventsFailure(deviceId, err));
        return;
    }
}
